import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckboxComponent } from './CheckboxComponent';
import { TextInputComponent } from './TextInputComponent';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { SelectComponentV2 } from './SelectComponentV2';

import {
  AppTheme,
  AppStyles
} from '../styles/AppTheme';
import { ColourPalette } from '../styles/AppColourPalette';
import {
  StyleSheet,
  css
} from 'aphrodite';

export class CustomFormFieldsDialogV2 extends Component {

  constructor(props) {
    super(props);
    this.responseByKey = this.props.responseByKey || {}
    this.labelByAction = {
      lookup: 'NEXT',
      delete: 'DELETE',
      add: 'SAVE',
      edit: 'SAVE',
      upload: 'UPLOAD'
    }
    this.state = {
      dummy: true //TODO
    }
  }

  setValue = (value, key) => {
    this.responseByKey[key] = value
    this.setState({
      dummy: !this.state.dummy
    })
  }

  onSubmit = () => {
    this.validateFieldsAndSubmit()
  }

  validateFieldsAndSubmit() {
    console.log('validateFieldsAndSubmit')
    let valid = true
    for (const formField of this.props.formFields) {
      if (ValidationHelper.validateFields(formField, this.responseByKey[formField.key])) {
        valid = false
      }
    }
    if (valid) {
      this.props.onSuccess(this.responseByKey)
    }
  }

  getFormFieldContent = (formField) => {
    if (formField.type === 'input_text') {
      if(this.props.action === 'viewInfo' && formField.key === 'logoUrl') {
        return null
      } else {
        return (
          <TextInputComponent
            formField={formField}
            value={this.responseByKey[formField.key]}
            enableValidation={this.props.enableValidation}
            setValue={this.setValue}
            disabled={this.props.formDisabled || formField.disabled}
            action={this.props.action}
          />
        )
      }
    } else if (formField.type === 'checkbox') {
      return (
        <CheckboxComponent
          formField={formField}
          value={this.responseByKey[formField.key] ? this.responseByKey[formField.key] : []}
          enableValidation={this.props.enableValidation}
          setValue={this.setValue.bind(this)}
          disabled={this.props.formDisabled}
          action={this.props.action}
        />
      )
    } else if (formField.type === 'select_single') {
      return (
        <SelectComponentV2
          formField={formField}
          value={this.responseByKey[formField.key]}
          setValue={this.setValue}
          enableValidation={this.props.enableValidation}
          disabled={this.props.formDisabled}
          action={this.props.action}
        />
      )
    }
  }

  generateContent = () => {
    const leftFields = []
    const rightFields = []
    const fullLengthFields = []

    for (const formField of this.props.formFields) {
      if (formField.placement === 'left') {
        leftFields.push(this.getFormFieldContent(formField))
      } else if (formField.placement === 'right') {
        rightFields.push(this.getFormFieldContent(formField))
      } else if (formField.placement === 'full') {
        fullLengthFields.push(this.getFormFieldContent(formField))
      }
    }

    return (
      <div className={css(Styles.fieldsOuterContainer)}>
        <div className={css(Styles.fieldsInnerContainerOne)}>
          <div className={css(Styles.fieldsOuterContainer)}>
            {leftFields}
          </div>
          <div className={css(Styles.fieldsOuterContainer)}>
            {rightFields}
          </div>
        </div>
        <div className={css(Styles.fieldsOuterContainer)}>
          {fullLengthFields}
        </div>
      </div>
    )
  }
  render() {
    this.responseByKey = this.props.responseByKey || {}
    return (
      <Dialog
        disableBackdropClick={true}
        onClose={this.props.onClose}
        open={this.props.dialogOpen}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            <p className={css(Styles.dialogTitleContent)}>{this.props.dialogTitle}</p>
            <div className={css(Styles.closeIconContainer)} onClick={this.props.onClose}>
              <img src={require('../assets/images/close-img.svg')} className={css(Styles.closeIcon)} />
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.props.confirmDeleteView &&
              <div>
                <p className={css(Styles.deleteConfirmMsg)}>Are you sure you want to delete?</p>
                <p className={css(Styles.deleteConfirmMsg)}>This action cannot be undone.</p>
              </div>
            }
            {!this.props.confirmDeleteView &&
            <div className={this.props.action === 'viewInfo' ?
              css(Styles.fieldsInnerMainContainer) : css(Styles.fieldsInnerMainContainer,Styles.fieldsViewInnerMainContainer)}>
              {this.props.formFields.map(item => {
                return (
                  (item.key === 'logoUrl' && this.props.action === 'viewInfo') &&
                  <div className={css(Styles.fieldsInnerMainContent)}>
                    <p className={css(Styles.fieldsInnerLabelContainer)}>Site Image</p>
                    <div className={css(Styles.fieldsInnerImgContainer)}>
                      <img
                        src={this.responseByKey.logoUrl ? this.responseByKey.logoUrl : require('../assets/images/location-img.svg')}
                        onError={(e) => {
                          e.target.src = 'https://uv-misc-test.s3.ap-south-1.amazonaws.com/location-img.svg'
                        }}
                        className={css(Styles.fieldsInnerImgContent)} />
                    </div>
                  </div>
                )
              })}
              <div className={css(Styles.fieldsInnerContainer)}>
                {this.props.formFields &&
                  this.generateContent()
                }
              </div>
            </div>
            }
          </div>
        </DialogContent>
        {this.props.action !== 'viewInfo' &&
          <DialogActions className={css(Styles.dialogActions)}>
            <div className={css(Styles.dialogActionsInnerContainer)}>
              {this.props.errMsg &&
                <p className={css(Styles.deleteMsg)}>{this.props.errMsg}</p>
              }
              <div className={css(Styles.dialogActionsInnerContainerButton)}>
                {this.props.confirmDeleteView &&
                  <Button
                    disabled={this.props.inProcess}
                    variant='contained'
                    onClick={e => this.props.deleteItem()}
                    className={css(Styles.buttonStyle)}>
                    DELETE
                    {this.props.inProcess && <CircularProgress color='primary' size={20} className={css(Styles.circulerProgress)} />}
                  </Button>
                }
                {!this.props.confirmDeleteView && this.props.action &&
                  <Button
                    disabled={this.props.inProcess}
                    variant='contained'
                    onClick={this.props.action === 'delete' ?
                      e => this.props.showConfirmDeleteView() :
                      e => this.onSubmit()}
                    className={css(Styles.buttonStyle)}>
                    {this.labelByAction[this.props.action]}
                    {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(Styles.circulerProgress)} />}
                  </Button>
                }
              </div>
            </div>
          </DialogActions>
        }
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialog: {
    minWidth: 850,
    '@media(max-width: 768px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    backgroundColor: AppTheme.white,
    padding: 20,
    '@media(max-width: 767px)': {
      padding: '20px 13px'
    }
  },
  dialogTitleContainer: {
    display: 'flex'
  },
  dialogTitleContent: {
    margin: 0,
    fontSize: AppTheme.fontSizeTitle,
    cursor: 'default',
    flex: 1,
  },
  closeIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer'
  },
  dialogContent: {
    backgroundColor: AppTheme.primaryBackground,
    display: 'flex',
    justifyContent: 'center',
    padding: '25px 25px 0px',
    '@media(max-width: 767px)': {
      padding: '5px 5px 0px',
    }
  },
  fieldsContainer: {
    width: '100%'
  },
  fieldsInnerLabelContainer: {
    margin: 0,
    color: AppTheme.white,
    opacity: 0.6,
    fontSize: 12,
    marginBottom: 5
  },
  fieldsInnerMainContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  fieldsViewInnerMainContainer: {
    justifyContent: 'center'
  },
  fieldsInnerMainContent: {
    marginTop: 4,
    marginRight: 60
  },
  fieldsInnerImgContainer: {
    maxWidth: 180,
    maxHeight: 180
  },
  fieldsInnerImgContent: {
    width: '100%',
    height: '100%'
  },
  fieldsInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  dialogActions: {
    backgroundColor: AppTheme.primaryBackground,
    display: 'flex',
    justifyContent: 'center',
    padding: 24,
    paddingTop: 0,
    marginTop: -5,
    '@media(max-width: 767px)': {
      padding: 5,
      paddingBottom: 20
    }
  },
  dialogActionsInnerContainer: {
    width: '100%',
    display: 'flex',
  },
  dialogActionsInnerContainerButton: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  deleteMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    fontWeight: 'bold',
    color: AppTheme.white,
    fontSize: 15,
    cursor: 'defalut',
    marginLeft: 8
  },
  buttonStyle: {
    marginRight: 8,
    backgroundColor: ColourPalette.color3,
    borderRadius: 4,
    color: AppTheme.white,
    fontWeight: 'bold',
    fontSize: 11,
    padding: '5px 16px'
  },
  circulerProgress: {
    marginLeft: 10,
    color: AppTheme.white
  },
  deleteConfirmMsg: {
    color: AppTheme.white,
    cursor: 'default'
  },
  fieldsOuterContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  fieldsInnerContainerOne: {
    display: 'flex'
  }
})


// WEBPACK FOOTER //
// ./src/components/CustomFormFieldsDialogV2.js